'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dName$0024$0024anon$0024110 from "./presto.types$-Rule-Name$$anon$110.js";
import * as $j_presto$002etypes$0024$002dRule$002dName$0024$0024anon$0024111 from "./presto.types$-Rule-Name$$anon$111.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RuleName$() {
  this.cbF = null;
  this.cbG = false;
  this.cbJ = null;
  this.cbK = false;
  this.cbH = null;
  this.cbI = false;
  this.cbL = null;
  this.cbM = false;
}
export { $c_Lpresto_types$RuleName$ as $c_Lpresto_types$RuleName$ };
$p = $c_Lpresto_types$RuleName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RuleName$;
/** @constructor */
function $h_Lpresto_types$RuleName$() {
}
export { $h_Lpresto_types$RuleName$ as $h_Lpresto_types$RuleName$ };
$h_Lpresto_types$RuleName$.prototype = $p;
$p.cJh = (function() {
  if ((!this.cbG)) {
    this.cbF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cbG = true;
  }
  return this.cbF;
});
$p.cta = (function() {
  if ((!this.cbK)) {
    this.cbJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cbK = true;
  }
  return this.cbJ;
});
$p.ct4 = (function() {
  if ((!this.cbI)) {
    this.cbH = new $j_presto$002etypes$0024$002dRule$002dName$0024$0024anon$0024110.$c_Lpresto_types$RuleName$$anon$110(this);
    this.cbI = true;
  }
  return this.cbH;
});
$p.aej = (function() {
  if ((!this.cbM)) {
    this.cbL = new $j_presto$002etypes$0024$002dRule$002dName$0024$0024anon$0024111.$c_Lpresto_types$RuleName$$anon$111(this);
    this.cbM = true;
  }
  return this.cbL;
});
var $d_Lpresto_types$RuleName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RuleName$, "presto.types$RuleName$", ({
  a1x: 1,
  D: 1
}));
export { $d_Lpresto_types$RuleName$ as $d_Lpresto_types$RuleName$ };
var $n_Lpresto_types$RuleName$;
function $m_Lpresto_types$RuleName$() {
  if ((!$n_Lpresto_types$RuleName$)) {
    $n_Lpresto_types$RuleName$ = new $c_Lpresto_types$RuleName$();
  }
  return $n_Lpresto_types$RuleName$;
}
export { $m_Lpresto_types$RuleName$ as $m_Lpresto_types$RuleName$ };
//# sourceMappingURL=presto.types$-Rule-Name$.js.map
